import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { fetchAuthSession } from "@/authSessionClient";

export function EvolutionKitGate({ children }: { children: React.ReactNode }) {
  const [allowed, setAllowed] = useState<boolean | null>(null);

  useEffect(() => {
    fetchAuthSession()
      .then((r) => r.json())
      .then((d: { authenticated?: boolean; isEvolutionKit?: boolean }) => {
        setAllowed(Boolean(d.authenticated && d.isEvolutionKit));
      })
      .catch(() => setAllowed(false));
  }, []);

  if (allowed === null) {
    return (
      <div className="min-h-screen text-white flex items-center justify-center bg-black">
        <p className="text-gray-400">Loading…</p>
      </div>
    );
  }

  if (!allowed) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
